import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LuX } from 'react-icons/lu'
import { Box, Flex } from '@chakra-ui/react'
import { ProductCategory } from '@leid/api-products'

import { getCategoryName } from 'components/nav/CategoriesMenu/utils/categories'
import { CategoryCard } from 'components/ui/Card/CategoryCard'
import LeidModal from 'components/ui/Modal/LeidModal'
import CategoriesContext from 'contexts/CategoriesContext'

import { CategoriesWrapper } from './styles'

type Props = {
  isOpen: boolean
  onClose: () => void
  handleSelectCategory: (category: ProductCategory) => void
  selectedCategory: number | undefined
}

export const CategoriesModal: React.FC<Props> = ({ isOpen, onClose, handleSelectCategory, selectedCategory }) => {
  const { t } = useTranslation('common')
  const { categories } = useContext(CategoriesContext)

  return (
    <LeidModal
      header={
        <Flex direction="row" justifyContent="space-between" alignItems="center" width="100%">
          <Box as="span" lineHeight={1}>
            {t('categories')}
          </Box>

          <Box style={{ cursor: 'pointer' }}>
            <LuX size={32} onClick={onClose} />
          </Box>
        </Flex>
      }
      size="full"
      isOpen={isOpen}
      onClose={onClose}
    >
      <CategoriesWrapper>
        {categories
          .filter((s) => s.parentCategoryId === undefined)
          .map((category) => (
            <Box
              key={category.id}
              onClick={() => {
                onClose()
                handleSelectCategory(category)
              }}
            >
              <CategoryCard
                key={category.id}
                isCategorySelected={selectedCategory === category.id}
                category={{
                  id: category.id,
                  name: getCategoryName(category),
                  url: category.imageUrl,
                }}
              />
            </Box>
          ))}
      </CategoriesWrapper>
    </LeidModal>
  )
}
